<template>
  <div class="left-table-list" >
<!--    <div class="table-page-search-wrapper">-->
<!--      <a-form layout="inline" @keyup.enter.native="searchQuery">-->
<!--        <a-row :gutter="24">-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24" style="width: 100%">-->
<!--            <div style="overflow: hidden;display: flex;margin-top: 0px" class="table-page-search-submitButtons">-->
<!--              <div class="common-btn-box" >-->

<!--              </div>-->
<!--              <div class="car-more-box" v-if="dataSource && dataSource.length">-->
<!--                <img :src="getFileAccessHttpUrl(dataSource[0].updateByAvatar)" v-if="dataSource[0].updateByAvatar"/>-->
<!--                <span>{{dataSource[0].updateByName}}</span>-->
<!--                <span>更新于{{dataSource[0].updateTime}}</span>-->
<!--              </div>-->
<!--              <div class="car-more-box" v-else>-->

<!--              </div>-->
<!--            </div>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--      </a-form>-->
<!--    </div>-->
    <div>
  <a-table
    ref="table"
    size="middle"
    :scroll="{x:true}"
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    class="j-table-force-nowrap"
    :customRow="customRow"
    :customHeaderRow="customHeaderRow"
    @change="handleTableChange">

  </a-table>
    </div>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getFileAccessHttpUrl,deleteAction } from '@/api/manage'
  export default {
    name: 'GmvTable',
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      ddpId:{
        type:String,
        default:''
      }
    },data(){
      return {
        columns: [
          {
            title: '统计月份',
            dataIndex: 'monthStr',
            align:"center",
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title:'月完单量(单)',
            align:"center",
            dataIndex: 'finishOrder',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title:'基础收入(元)',
            align:"center",
            dataIndex: 'income',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '在线天数',
            align:"center",
            dataIndex: 'onlineDays',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '操作人',
            align:"center",
            dataIndex: 'createName',
            customRender:function (t,r,index) {
              return t || '-';
            }
          }
        ],
        url: {
          list: "/dm/dmPlatformGmv/list"
        },disableMixinCreated:true
      }
    },methods:{
      getFileAccessHttpUrl,
      loadList(){
        this.queryParam.ddpId = this.ddpId;
        this.loadData();
      },customRow(record){
        let clas = "row-class"
        return {
          class:clas
        }
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/tableList.less';
@import '~@assets/less/dm/newTable.less';
/deep/ th[key='selection-column']{
  padding: 12px 22px !important
}
.left-table-list{
  margin-top: 0 !important;
}
.car-more-box{
  width: 376px;
  background: #fff;
  border-radius: 18px;
  padding:7px 18px;
}
.car-more-box img{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: sub;
}
.car-more-box span{
  margin-left: 9px;
}
</style>